import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useSettings } from './contexts/SettingsContext'

function Contact() {
  const { settings } = useSettings()
  const isDark = settings.generalSettings.theme === 'dark'
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  })

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    // In a real app, this would submit to a backend
    alert('Thank you for your message! This is a demo - in a real app, this would send an email.')
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    })
  }

  return (
    <div className={`min-h-screen ${isDark ? 'dark bg-gray-900' : 'bg-gray-50'}`}>
      <div className="max-w-4xl mx-auto p-4 md:p-6">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-primary dark:text-primary-dark">
              Contact Us
            </h1>
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
              Get in touch with our team
            </p>
          </div>
          <Link
            to="/"
            className="px-4 py-2 rounded-lg bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors text-sm"
          >
            ← Back to App
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Contact Form */}
          <div className="lg:col-span-2">
            <div className={`bg-white dark:bg-gray-800 p-4 md:p-6 rounded-lg border ${isDark ? 'border-gray-700' : 'border-gray-200'}`}>
              <h2 className="text-lg md:text-xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
                Send us a Message
              </h2>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className={`w-full px-3 py-2 border ${isDark ? 'border-gray-600 bg-gray-700 text-white' : 'border-gray-300 bg-white text-gray-900'} rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent`}
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Email
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className={`w-full px-3 py-2 border ${isDark ? 'border-gray-600 bg-gray-700 text-white' : 'border-gray-300 bg-white text-gray-900'} rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent`}
                      required
                    />
                  </div>
                </div>
                <div>
                  <label htmlFor="subject" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Subject
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    className={`w-full px-3 py-2 border ${isDark ? 'border-gray-600 bg-gray-700 text-white' : 'border-gray-300 bg-white text-gray-900'} rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent`}
                    required
                  />
                </div>
                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="4"
                    className={`w-full px-3 py-2 border ${isDark ? 'border-gray-600 bg-gray-700 text-white' : 'border-gray-300 bg-white text-gray-900'} rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent`}
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="px-4 py-2 bg-primary hover:bg-primary-dark text-white font-medium rounded-lg transition-colors"
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <div className={`bg-white dark:bg-gray-800 p-4 md:p-6 rounded-lg border ${isDark ? 'border-gray-700' : 'border-gray-200'}`}>
              <h3 className="font-semibold text-gray-800 dark:text-gray-200 mb-3">Contact Information</h3>
              <div className="space-y-3">
                <div>
                  <div className="text-sm text-gray-600 dark:text-gray-400">Email</div>
                  <div className="text-primary dark:text-primary-dark">support@aigradingagent.com</div>
                </div>
                <div>
                  <div className="text-sm text-gray-600 dark:text-gray-400">Support Hours</div>
                  <div className="text-gray-700 dark:text-gray-300">Mon-Fri, 9AM-5PM EST</div>
                </div>
                <div>
                  <div className="text-sm text-gray-600 dark:text-gray-400">Response Time</div>
                  <div className="text-gray-700 dark:text-gray-300">Within 24-48 hours</div>
                </div>
              </div>
            </div>

            <div className={`bg-white dark:bg-gray-800 p-4 md:p-6 rounded-lg border ${isDark ? 'border-gray-700' : 'border-gray-200'}`}>
              <h3 className="font-semibold text-gray-800 dark:text-gray-200 mb-3">Common Questions</h3>
              <div className="space-y-2">
                <div>
                  <div className="text-sm font-medium text-gray-700 dark:text-gray-300">API Integration</div>
                  <div className="text-xs text-gray-600 dark:text-gray-400">Learn about integrating with your LMS</div>
                </div>
                <div>
                  <div className="text-sm font-medium text-gray-700 dark:text-gray-300">Bulk Licensing</div>
                  <div className="text-xs text-gray-600 dark:text-gray-400">Information for educational institutions</div>
                </div>
                <div>
                  <div className="text-sm font-medium text-gray-700 dark:text-gray-300">Feature Requests</div>
                  <div className="text-xs text-gray-600 dark:text-gray-400">Suggest new features or improvements</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact
